import axios from "axios";
import i18n from "../../../../../i18n";

// Constants
const SET_ANALYTICS_DATA = "SET_ANALYTICS_DATA";
const RESET_STATE = "RESET_STATE";
const SET_SURVEY_MODEL = "SET_SURVEY_MODEL";

// Acessors
const getSurveyAnalyticsModel = (state, widgetId) => state[widgetId]?.model;
const getSurveyDefinitionId = (state, widgetId) =>
  state[widgetId]?.surveyDefinitionID;
const getSurveyDefinition = (state, widgetId) =>
  state[widgetId]?.surveyDefiniton;

// Default state
const initialState = {};

export const surveyAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ANALYTICS_DATA: {
      const { data, widgetId } = action;
      return {
        ...state,
        [widgetId]: {
          ...state[widgetId],
          surveyDefinitionID: data[0]["surveyDefinitionID"],
          model: data.map((answer, i) => JSON.parse(answer.model)),
        },
      };
    }

    case SET_SURVEY_MODEL: {
      const { data, widgetId } = action;
      return {
        ...state,
        [widgetId]: {
          ...state[widgetId],
          surveyDefiniton: { ...data, model: JSON.parse(data.model) },
        },
      };
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

const fetchSurveyAnalyticsData =
  (surveyDefinitionCmsId, surveyDefinitionCmsVersion, widgetId) =>
  (dispatch) => {
    const params = {
      surveyDefinitionCmsId: surveyDefinitionCmsId,
      surveyDefinitionCmsVersion: surveyDefinitionCmsVersion,
    };
    return axios
      .get("/api/survey/response/all", {
        params,
      })
      .then(({ data }) => {
        dispatch({
          type: SET_ANALYTICS_DATA,
          data: data,
          widgetId,
        });
        return Promise.resolve(data[0]["surveyDefinitionID"]);
      })
      .catch(() => {
        return Promise.reject(i18n.t("errorText.dashboard.get"));
      });
  };

const fetchSurveyModel = (surveyDefinitionID, widgetId) => (dispatch) => {
  return axios
    .get(`/api/survey/definition/${surveyDefinitionID}`)
    .then(({ data }) =>
      dispatch({
        type: SET_SURVEY_MODEL,
        data: data,
        widgetId,
      })
    )
    .catch(() => {
      return Promise.reject(
        i18n.t("errorText.dietDiary.dailyTargets.history.get")
      );
    });
};

export const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

export const mapStateToProps = (state, ownProps) => {
  const { widgetId } = ownProps;
  return {
    surveyAnswers: getSurveyAnalyticsModel(state, widgetId),
    surveyDefinitionID: getSurveyDefinitionId(state, widgetId),
    surveyDefinition: getSurveyDefinition(state, widgetId),
  };
};

export const mapDispatchToProps = {
  fetchSurveyAnalyticsData,
  fetchSurveyModel,
  resetState,
};
